// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { DeviceControllerInfoContent, unionToDeviceControllerInfoContent, unionListToDeviceControllerInfoContent } from './device-controller-info-content';
import { ElevatorControllerInfoMessage, ElevatorControllerInfoMessageT } from './elevator-controller-info-message';
import { EscalatorControllerInfoMessage, EscalatorControllerInfoMessageT } from './escalator-controller-info-message';


export class ControllerInfoMessage implements flatbuffers.IUnpackableObject<ControllerInfoMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ControllerInfoMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsControllerInfoMessage(bb:flatbuffers.ByteBuffer, obj?:ControllerInfoMessage):ControllerInfoMessage {
  return (obj || new ControllerInfoMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsControllerInfoMessage(bb:flatbuffers.ByteBuffer, obj?:ControllerInfoMessage):ControllerInfoMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ControllerInfoMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

messageType():DeviceControllerInfoContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceControllerInfoContent.NONE;
}

message<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startControllerInfoMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessageType(builder:flatbuffers.Builder, messageType:DeviceControllerInfoContent) {
  builder.addFieldInt8(0, messageType, DeviceControllerInfoContent.NONE);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, messageOffset, 0);
}

static endControllerInfoMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // message
  return offset;
}

static createControllerInfoMessage(builder:flatbuffers.Builder, messageType:DeviceControllerInfoContent, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  ControllerInfoMessage.startControllerInfoMessage(builder);
  ControllerInfoMessage.addMessageType(builder, messageType);
  ControllerInfoMessage.addMessage(builder, messageOffset);
  return ControllerInfoMessage.endControllerInfoMessage(builder);
}

unpack(): ControllerInfoMessageT {
  return new ControllerInfoMessageT(
    this.messageType(),
    (() => {
      const temp = unionToDeviceControllerInfoContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: ControllerInfoMessageT): void {
  _o.messageType = this.messageType();
  _o.message = (() => {
      const temp = unionToDeviceControllerInfoContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class ControllerInfoMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public messageType: DeviceControllerInfoContent = DeviceControllerInfoContent.NONE,
  public message: ElevatorControllerInfoMessageT|EscalatorControllerInfoMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const message = builder.createObjectOffset(this.message);

  return ControllerInfoMessage.createControllerInfoMessage(builder,
    this.messageType,
    message
  );
}
}
